import React from 'react';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';
import { CircleIcon } from '@zola/zola-ui/src/components/CircleIcon';
import { LightBulb2 } from '@zola/zola-ui/src/assets/images/icons';
import { connect } from 'react-redux';
import { hideModal } from 'cards/actions/modalActions';
import styles from './styles.module.less';

const DigitalTips = ({ onConfirm }) => (
  <div className={styles.container}>
    <CircleIcon image={LightBulb2} size={100} variant="cream" />
    <div className={styles.header}>Set your guests up for success</div>
    <div className={styles.content}>
      <div>
        Like a great wedding appetizer, save the dates set the tone for the celebration to come.
        Make sure you give guests what they need to know:
      </div>
      <ul className={styles.digitalTipsList}>
        <li>Your names</li>
        <li>Your wedding date</li>
        <li>Your wedding location or city</li>
        <li>Indication of an invitation to follow</li>
        <li>
          Your wedding website and password - create one that matches your save the date for *free*!
        </li>
      </ul>
      <div>
        At a loss for words? Check out expert advice on crafting save the dates for all kinds of
        weddings.
      </div>
    </div>
    <div className={styles.buttonContainer}>
      <ButtonV2 onClick={onConfirm}>Got It</ButtonV2>
    </div>
  </div>
);

const mapDispatchToProps = dispatch => ({
  onConfirm: () => dispatch(hideModal()),
});

export default connect(null, mapDispatchToProps)(DigitalTips);
